export class DiveRE {
    constructor() {}
    commonStep = 'stepper.form.commun.divers.step';
    step = 'stepper.form.dive_re.step';
    step4 = 'stepper.form.dive_re.step4';
    step5 = 'stepper.form.dive_re.step5';
    step6 = 'stepper.form.dive_re.step5';
    step7 = 'stepper.form.dive_re.step7';
    step10 = 'stepper.form.dive_re.step10';
    step11 = 'stepper.form.dive_re.step11';
  }
